// extracted by mini-css-extract-plugin
export default {"home":"Museum_home__aesAi","arrow":"Museum_arrow__abP3x","title":"Museum_title__e4HwE","songs":"Museum_songs__XSU5a","link":"Museum_link__kZCwS"};